module.exports = __webpack_public_path__ + "img/reg-select-arrow.661f08d6.svg";